import { render, staticRenderFns } from "./HandHoldingGlobe.vue?vue&type=template&id=ecf25a4c&scoped=true&"
import script from "./HandHoldingGlobe.vue?vue&type=script&lang=js&"
export * from "./HandHoldingGlobe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf25a4c",
  null
  
)

export default component.exports